import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../store";
import PersonalInfo from "../../personalInfo/PersonalInfo";

type Props = PropsFromRedux & {};

const AdminPreferences = (props: Props) => {
  return (
    <div className="PageWrapper">
      <div className="AdminPreferencesLayout">
        <PersonalInfo />
      </div>
    </div>
  );
};

type PropsFromRedux = ConnectedProps<typeof connector>;

const mapStateToProps = (state: RootState) => {
  return {};
};

const mapDispatch = {};

const connector = connect(mapStateToProps, mapDispatch);

export default connector(AdminPreferences);
